import { useCheckoutFlow } from "@/contexts/checkout-flow/checkout-flow.provider";
import { Show } from "solid-js";

const featuredDealerLogo = new URL(
  "../../shared/images/featured-dealer-logo.png",
  import.meta.url,
).href;

interface CheckoutHeaderProps {
  title: string | undefined;
}

export const CheckoutHeader = (props: CheckoutHeaderProps) => {
  const { totalPrice, currentStep } = useCheckoutFlow();

  return (
    <fd-mfe-container class="flex justify-between items-center shadow-FsElevationSurface01 px-FsSpacing15x py-FsSpacing1x mb-FsSpacing1x @xs:px-FsSizing3x @xs:py-FsSizing2x @xs:my-FsSizing2x">
      <div class="flex items-center gap-FsSpacing2x">
        <img
          src={featuredDealerLogo}
          class="hidden @xs:block max-w-[85px]"
          alt=""
        />
        <h1 class="font-FsFontFamily font-FsFontWeightSemibold text-FsFontSize125x my-0">
          {props.title}
        </h1>
      </div>
      <Show when={currentStep() !== "CANCEL"}>
        <div class="flex flex-col items-center" aria-live="polite">
          <div class="text-FsFontSize0875x text-FsClrNeutralGray550">
            Est. Total
          </div>
          <div class="text-FsFontSize0875x font-FsFontWeightSemibold @xs:text-FsFontSize1x @xs:font-FsFontWeightRegular">
            ${totalPrice()}
          </div>
        </div>
      </Show>
    </fd-mfe-container>
  );
};
